var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDniBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466.373,69.818H47.564C21.873,69.818,0,90.053,0,115.689v279.374c0,25.635,21.873,47.119,47.564,47.119h418.809 c25.691,0,45.627-21.484,45.627-47.119V115.689C512,90.053,492.064,69.818,466.373,69.818z M493.382,395.062 c0,15.372-11.582,28.501-27.009,28.501H47.564c-15.427,0-28.945-13.13-28.945-28.501V115.689 c0-15.373,13.518-27.252,28.945-27.252h418.809c15.427,0,27.009,11.88,27.009,27.252V395.062z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.182,134.982h-55.855c-15.4,0-28.891,11.902-28.891,27.298v55.864c0,15.397,13.491,28.548,28.891,28.548h55.855 c15.4,0,26.964-13.151,26.964-28.548V162.28C456.145,146.884,444.582,134.982,429.182,134.982z M437.527,218.768 c0,5.139-4.168,9.304-9.309,9.304h-55.855c-5.141,0-9.309-4.166-9.309-9.304v-55.864c0-5.139,4.168-9.304,9.309-9.304h55.855 c5.141,0,9.309,4.166,9.309,9.304V218.768z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243,302.545H66.127c-5.146,0-9.309,4.168-9.309,9.309s4.163,9.309,9.309,9.309H243c5.145,0,9.309-4.168,9.309-9.309 S248.145,302.545,243,302.545z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243,349.091H66.127c-5.146,0-9.309,4.168-9.309,9.309c0,5.141,4.163,9.309,9.309,9.309H243 c5.145,0,9.309-4.168,9.309-9.309C252.309,353.259,248.145,349.091,243,349.091z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDniBack);
export default __webpack_public_path__ + "static/media/DniBack.7c8be5bb13ec9e06e41b51b91ec659a0.svg";
export { ForwardRef as ReactComponent };